export const actionStatusAssigned = 1;
export const actionStatusAccepted = 2;
export const actionStatusDone = 3;
export const actionStatusCompleted = 4;
export const actionStatusDeclined = 5;
